import React from "react";
import { Fragment } from "react";
import HeaderHome from "../layout/HeaderHome";
import SliderEmpresas from "../layout/SliderEmpresas";
import SliderAliados from "../layout/SliderAliados";

import laptop from "../static/images/laptop2.png";
import tablets from "../static/images/tablets02.png";
import publica_vacantes from "../static/images/publica_vacantes.svg";
import agenda_entrevistas from "../static/images/agenda_entrevistas.svg";
import icononetworking from "../static/images/icono-networking.svg";
import comparte_contenido_relevante from "../static/images/comparte_contenido_relevante.svg";
import interactua_con_tu_comunidad from "../static/images/interactua_con_tu_comunidad.svg";
import crea_tu_propios_eventos from "../static/images/crea_tu_propios_eventos.svg";
import comunicacion_directa_con_tu_red from "../static/images/comunicacion_directa_con_tu_red.svg";

import gear_wheel from "../static/images/gear-wheel.svg";
import bg_testimonial from "../static/images/bg-testimonial.png";
import bg_testimonial12 from "../static/images/bg-testimonial2.png";
import FooterHome from "../layout/FooterHome";

function Empresas() {
  const images = [
    {
      url: laptop,
      tittle: "EMPRESAS",
      content:
        "Encuentra y selecciona al mejor talento humano, publica ofertas laborales y posiciona tu empresa.",
    },
    {
      url: tablets,
      tittle: "EMPRESAS",
      content:
        "Encuentra y selecciona al mejor talento humano, publica ofertas laborales y posiciona tu empresa.",
    },
  ];

  return (
    <Fragment>
      <HeaderHome></HeaderHome>
      <section id="hero" className="hero">
        <img src={gear_wheel} alt="" className="hero__gear rotate"></img>
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-sm-10 px-0">
              <SliderEmpresas images={images}></SliderEmpresas>
            </div>
          </div>
        </div>
      </section>
      <section className="socios">
        <div className="container">
          <div className="row seven-cols">
            {/* <img src={empuje} style={{ height: "250px", width: "400px" }}></img>
           <div className="col">
              <a href="https://www.canada.ca/en.html">
                <img src={canada} alt="canada"></img>
              </a>
            </div>
            <div className="col ln-border">
              <a href="https://childrenbelieve.ca/">
                <img src={childre} alt="childre"></img>
              </a>
            </div>
            <div className="col text-right">
              <span className="title">SOCIOS</span>
            </div>
            <div className="col c-13">
              <a href="https://cep.empuje.org/">
                <img src={cep} alt="cep"></img>
              </a>
            </div>
            <div className="col c-13">
              <a href="https://www.heifer.org/">
                <img src={heifer} alt="heifer"></img>
              </a>
            </div>
            <div className="col c-13">
              <a href="https://www.tecnacional.edu.ni/">
                <img src={inatec} alt="inatec"
                  style={{ width: "130px", height: "85px" }}
                ></img>
              </a>
            </div>*/}
          </div>
        </div>
      </section>
      <section className="comunidad empresa">
        <div className="container">
          <div className="title">
            Conéctate con el mejor talento que hemos{" "}
            <span>desarrollado para tu empresa.</span>
          </div>
          <div className="sub-title">
            Nuestra tecnología te permitirá facilitar el proceso de contratación
            con las candidatas y candidatos{" "}
            <span>para conseguir el talento que estas buscando.</span>
          </div>

          <div className="row justify-content-center mt-5">
            <div className="col-12 col-md-6 col-lg-4 col-xl-4 kr-box">
              <div className="wrapper">
                <img src={publica_vacantes}></img>
                <h3>
                  Publica y gestiona <span>tus vacantes</span>
                </h3>
              </div>
            </div>

            <div className="col-12 col-md-6 col-lg-4 col-xl-4 kr-box">
              <div className="wrapper">
                <img src={agenda_entrevistas}></img>
                <h3>
                  Agenda <span>entrevistas</span>
                </h3>
              </div>
            </div>

            <div className="col-12 col-md-6 col-lg-4 col-xl-4 kr-box">
              <div className="wrapper">
                <img src={icononetworking}></img>
                <h3>
                  Recibe reportes <span>predeterminados y</span> dinámicos
                </h3>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="experiencia empresa">
        <div className="container">
          <div className="title">
            Comparte la marca de tu empresa. Personaliza tu perfil{" "}
            <span>y cuenta tu historia para posicionar tu imagen en las</span>{" "}
            posibles candidatas y candidatos.
          </div>

          <div className="row">
            <div className="col text-center">
              <img src={comparte_contenido_relevante}></img>
              <p>Desarrolla y comparte contenido relevante.</p>
            </div>

            <div className="col text-center">
              <img src={interactua_con_tu_comunidad}></img>
              <p>Forma grupos de interés e interactúa con tu comunidad.</p>
            </div>

            <div className="col text-center">
              <img src={crea_tu_propios_eventos}></img>
              <p>Crea tus propios eventos.</p>
            </div>

            <div className="col text-center">
              <img src={comunicacion_directa_con_tu_red}></img>
              <p>Establece una comunicación directa con tu red.</p>
            </div>
          </div>
        </div>
      </section>
      {/*
      <section className="casos-estudios">
        <div className="container">
          <div className="title">Conociendo nuestra experiencia Krezco</div>
          <div className="row">
            <div className="col-md-12">
              <div id="testimonial-slider-2">
                <div
                  id="carouselExampleControls"
                  className="carousel slide"
                  data-bs-ride="carousel"
                  data-bs-interval="5000"
                  data-bs-touch="true"
                >
                  <div className="carousel-inner">
                    <div className="carousel-item active">
                      <div className="testimonials">
                        <div className="testimonial-content">
                          
                          <div className="description">
                            <p>
                              ...
                            </p>
                            <p>
                              ...
                            </p>

                            <h3 className="testimonial-title">Roberto Gomez</h3>
                          </div>
                        </div>
                        <div className="pic">
                          <img src={bg_testimonial} alt=""></img>
                        </div>
                      </div>
                    </div>
                    <div className="carousel-item">
                      <div className="testimonials">
                        <div className="testimonial-content">
                          
                          <div className="description">
                            <p>
                             ...
                            </p>
                            <p>
                              ...
                            </p>

                            <h3 className="testimonial-title">Roberto Gomez</h3>
                          </div>
                        </div>
                        <div className="pic">
                          <img src={bg_testimonial12} alt=""></img>
                        </div>
                      </div>
                    </div>
                  </div>
                  <button
                    class="carousel-control-prev"
                    type="button"
                    data-bs-target="#carouselExampleControls"
                    data-bs-slide="prev"
                  >
                    <span
                      class="carousel-control-prev-icon"
                      aria-hidden="true"
                    ></span>
                    <span class="visually-hidden">Previous</span>
                  </button>
                  <button
                    class="carousel-control-next"
                    type="button"
                    data-bs-target="#carouselExampleControls"
                    data-bs-slide="next"
                  >
                    <span
                      class="carousel-control-next-icon"
                      aria-hidden="true"
                    ></span>
                    <span class="visually-hidden">Next</span>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    */}
{/*
      <section className="aliados empresa">
        <div className="container">
          <div className="title">Nuestros Aliados</div>
          <div className="row">
            <SliderAliados></SliderAliados>
          </div>
        </div>
      </section>

*/}
     <section className="news">
      {/* <div className="title">Últimas Publicaciones</div>
        <div className="container" >      
        <div className="row">

          <div className="leerMas">                       
              <a href="https://cep.empuje.org/blog/" target="_blank"  > Leer Mas</a>
            </div>
         </div>
         </div>
        {/*
        <div className="container">
          <div className="title">Últimas publicaciones</div>
          <div className="row">
            <div className="col-sm-4">
              <img src={blog1}></img>
              <span>10 de Octubre, 2020</span>
              <h2>Guía para preparar una Entrevista de Trabajo</h2>
              <p>
                Prepara tu próxima entrevista, utiliza nuestra guía e informate
                de qué preguntas te pueden hacer y cómo responderlas, qué no
                debes decir, cómo explicar tus áreas a mejorar, qué preguntas
                puedes hacer, entre otros.
              </p>
              <a href="#">Leer más</a>
            </div>

            <div className="col-sm-4">
              <img src={blog2}></img>
              <span>09 de Octubre, 2020</span>
              <h2>
                Lista de control de <span>diversidad e inclusión</span>
              </h2>
              <p>
                La diversidad y la inclusión se mencionan a menudo en la misma
                frase, porque una organización inclusiva no puede existir sin
                uan fuerza de trabajo diversa. Y una organización debe ser
                inclusiva a fin de mantener su personal diverso.
              </p>
              <a href="#">Leer más</a>
            </div>

            <div className="col-sm-4">
              <img src={blog3}></img>
              <span>12 de Octubre, 2020</span>
              <h2>Diseña tu plan de carrera</h2>
              <p>
                El plan de carrera es una estrategia empresarial para conseguir
                talento valioso para las compañias. Te damos a conocer los
                secretos de esta táctica para poder ponerla en práctica.
              </p>
              <a href="#">Leer más</a>
            </div>
          </div>
        </div>
        */}
      </section>
      <FooterHome></FooterHome>
    </Fragment>
  );
}

export default Empresas;
